var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "privacyLockout" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "checkbox-container" },
      [
        _c(
          "v-checkbox",
          {
            attrs: { color: "primary", "hide-details": "" },
            model: {
              value: _vm.agree,
              callback: function($$v) {
                _vm.agree = $$v
              },
              expression: "agree"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "label-section",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("div", { staticClass: "name" }, [
                  _vm._v(
                    "I have read and agree to the Terms of Service and Privacy Policy."
                  )
                ])
              ]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "text-align": "center" } }, [
      _vm._v("Our "),
      _c(
        "a",
        { attrs: { href: "https://app.vilio.co/policy", target: "_blank" } },
        [_vm._v("Terms of Service and Privacy Policy")]
      ),
      _vm._v(" have been updated.")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _vm._v("\n    To continue using Vilio, you must agree to our updated "),
      _c(
        "a",
        { attrs: { href: "https://app.vilio.co/policy", target: "_blank" } },
        [_vm._v("Terms of Service and Privacy Policy")]
      ),
      _vm._v(".\n  ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a6f8a4b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a6f8a4b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrivacyLockout.vue
// module id = 539
// module chunks = 4